import { fetchAuthSession } from "aws-amplify/auth";

export const getAuthToken = async () => {
  const session = await fetchAuthSession();

  // In amplify v6, idToken is an object. .toString() gives you the raw JWT string.
  const token = session.tokens?.idToken?.toString();
  return token ?? null;
};

export const getTokenAndId = async (): Promise<{ token: string | null; userId: string | null }> => {
  const session = await fetchAuthSession();

  const token = session.tokens?.idToken?.toString() ?? null;
  // The 'sub' claim is the unique identifier for the user in Cognito
  const userId = session.tokens?.idToken?.payload.sub?.toString() ?? null;

  return { token, userId };
};
